module.exports = __webpack_public_path__ + "static/media/floating.7a2336b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/floating.png
// module id = 7
// module chunks = 0